var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_23692",
    "data-name": "Group 23692",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 169.667,
    viewBox: "0 0 150 169.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8344",
    "data-name": "Rectangle 8344",
    width: 150,
    height: 169.667,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23691",
    "data-name": "Group 23691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5509",
    "data-name": "Path 5509",
    d: "M100.948,112.608H15.029a8.744,8.744,0,0,1-8.743-8.743V17.946A8.743,8.743,0,0,1,15.029,9.2h85.919a8.743,8.743,0,0,1,8.743,8.742v85.919a8.744,8.744,0,0,1-8.743,8.743",
    transform: "translate(0.826 1.209)",
    fill: "#e9e4e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5510",
    "data-name": "Path 5510",
    d: "M62.122,153.776H39.3a7.829,7.829,0,0,1-7.829-7.829V123.12a7.829,7.829,0,0,1,7.829-7.829H62.122a7.829,7.829,0,0,1,7.829,7.829v22.826a7.829,7.829,0,0,1-7.829,7.829",
    transform: "translate(4.135 15.149)",
    fill: "#755449"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5511",
    "data-name": "Path 5511",
    d: "M94.045,35.323l34.314,34.314L90.154,107.843,51.95,69.637,86.264,35.323a5.5,5.5,0,0,1,7.781,0",
    transform: "translate(6.826 4.43)",
    fill: "#1c2442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5512",
    "data-name": "Path 5512",
    d: "M94.045,35.323l34.314,34.314L90.154,107.843,51.95,69.637,86.264,35.323A5.5,5.5,0,0,1,94.045,35.323Z",
    transform: "translate(6.826 4.43)",
    fill: "none",
    stroke: "#252d3b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M94.045,20.483,128.359,54.8,90.154,93,51.95,54.8,86.264,20.483A5.5,5.5,0,0,1,94.045,20.483Z",
    transform: "translate(6.826 2.48)",
    fill: "none",
    stroke: "#1c2442",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5514",
    "data-name": "Path 5514",
    d: "M39.88,118.405v26.588a8.03,8.03,0,0,0,8.031,8.03h88.18a8.03,8.03,0,0,0,8.031-8.03V56.812a8.031,8.031,0,0,0-8.031-8.03H47.911a8.031,8.031,0,0,0-8.031,8.03v55.268",
    transform: "translate(5.24 6.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5515",
    "data-name": "Path 5515",
    d: "M39.88,118.405v26.588a8.03,8.03,0,0,0,8.031,8.03h88.18a8.03,8.03,0,0,0,8.031-8.03V56.812a8.031,8.031,0,0,0-8.031-8.03H47.911a8.031,8.031,0,0,0-8.031,8.03v55.268",
    transform: "translate(5.24 6.41)",
    fill: "none",
    stroke: "#1c2442",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5516",
    "data-name": "Path 5516",
    d: "M124.806,13.96a4.4,4.4,0,1,0,4.4-4.4,4.4,4.4,0,0,0-4.4,4.4",
    transform: "translate(16.4 1.257)",
    fill: "#372724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M13.709,78.365a6.73,6.73,0,1,1-6.73-6.73,6.73,6.73,0,0,1,6.73,6.73",
    transform: "translate(0.033 9.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 6.73,
    cy: 6.73,
    r: 6.73,
    transform: "translate(0.283 81.048)",
    fill: "none",
    stroke: "#1c2442",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y1: 66.043,
    transform: "translate(21.502 103.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 66.043,
    transform: "translate(21.502 103.341)",
    fill: "none",
    stroke: "#1c2442",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M56.288,4.454A19.476,19.476,0,0,0,30.747,33.809l-5.406,2.786A1.426,1.426,0,0,0,26,39.287l18.337-.076A19.481,19.481,0,0,0,59.575,7.767",
    transform: "translate(3.228 0.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M56.288,4.454A19.476,19.476,0,0,0,30.747,33.809l-5.406,2.786A1.426,1.426,0,0,0,26,39.287l18.337-.076A19.481,19.481,0,0,0,59.575,7.767",
    transform: "translate(3.228 0.033)",
    fill: "none",
    stroke: "#1c2442",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M43,9.973l1.827,3.7a3.052,3.052,0,0,0,2.3,1.67l4.085.594a.693.693,0,0,1,.384,1.182L48.642,20a3.056,3.056,0,0,0-.879,2.7l.7,4.069a.693.693,0,0,1-1.006.731L43.8,25.584a3.056,3.056,0,0,0-2.842,0l-3.653,1.921a.693.693,0,0,1-1.006-.731l.7-4.069a3.056,3.056,0,0,0-.879-2.7l-2.955-2.882a.693.693,0,0,1,.384-1.182l4.085-.594a3.052,3.052,0,0,0,2.3-1.67l1.827-3.7A.693.693,0,0,1,43,9.973Z",
    transform: "translate(4.33 1.26)",
    fill: "none",
    stroke: "#1c2442",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M101.788,123.446h0a10.305,10.305,0,1,1,10.3-10.3,10.305,10.305,0,0,1-10.3,10.3",
    transform: "translate(12.021 13.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M101.788,123.446h0a10.305,10.305,0,1,1,10.3-10.3A10.305,10.305,0,0,1,101.788,123.446Z",
    transform: "translate(12.021 13.513)",
    fill: "none",
    stroke: "#1c2442",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M73.738,117.509h28.311a4.065,4.065,0,0,0,4.065-4.064V85.133a4.065,4.065,0,0,0-4.065-4.064H73.738a4.064,4.064,0,0,0-4.064,4.064v28.312a4.064,4.064,0,0,0,4.064,4.064",
    transform: "translate(9.155 10.653)",
    fill: "#a4cbe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8343",
    "data-name": "Rectangle 8343",
    d: "M3.592,0H32.847A3.593,3.593,0,0,1,36.44,3.593V32.848a3.592,3.592,0,0,1-3.592,3.592H3.592A3.592,3.592,0,0,1,0,32.848V3.592A3.592,3.592,0,0,1,3.592,0Z",
    transform: "translate(78.829 91.722)",
    fill: "none",
    stroke: "#1c2442",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPage);
export default __webpack_public_path__ + "static/media/empty-page.bb0363f20ee1735d2f4b048581f084bc.svg";
export { ForwardRef as ReactComponent };